import GlobalQuickJump from "../../../../../global/GlobalQuickJump";

export default function ToAndFroQuickJumpSection(props) {
  return <GlobalQuickJump {...props} />;
}
